import React, { useState } from 'react';
import { PageTransition } from '../../components/ui/PageTransition';
import { SEO } from '../../components/shared/SEO';
import { GamemodeImageList } from '../../components/admin/GamemodeImageList';
import { GamemodeImageForm } from '../../components/admin/GamemodeImageForm';
import { Link } from 'react-router-dom';

export function AdminImages() {
  const [showAddForm, setShowAddForm] = useState(false);

  return (
    <PageTransition>
      <SEO
        title="Gamemode Images"
        description="KaizenMC Admin Panel - Gamemode Images Management"
        noindex={true}
      />
      <div className="min-h-screen bg-gray-900 pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold text-white">Gamemode Images</h1>
            <Link
              to="/admin/home"
              className="text-gray-400 hover:text-white transition-colors"
            >
              Back to Home
            </Link>
          </div>

          {showAddForm ? (
            <div className="bg-gray-800 rounded-lg border border-gray-700 p-6 mb-8">
              <GamemodeImageForm
                onSuccess={() => setShowAddForm(false)}
                onCancel={() => setShowAddForm(false)}
              />
            </div>
          ) : (
            <GamemodeImageList onAddClick={() => setShowAddForm(true)} />
          )}
        </div>
      </div>
    </PageTransition>
  );
} 